import React from 'react';
import { connect } from 'react-redux';
import { makeStyles, Theme } from '@material-ui/core/styles';
import PinIcon from '../icons/PinIcon';
import MyEvaluationBoard from '../organisms/MyEvaluationBoard';
import PdfPageTemplate from './PdfPageTemplate';
import { getQueryParameter } from '../services/query-parameters';
import { State } from '../redux/reducers';
import { COLOR_LIGHT_GRAY } from '../styles/colors';
import User from '../types/User';
import Position from '../types/Position';

interface MyEvaluationBoardPageTemplateProps {
  user?: User;
}

const useStyles = makeStyles<Theme, MyEvaluationBoardPageTemplateProps>(theme => ({
  headerIcon: {
    width: '40px',
    height: '40px',
    marginRight: theme.spacing(1),
  },

  tableWrapper: {
    padding: theme.spacing(5),
  },

  titleRow: {
    border: `1px solid ${COLOR_LIGHT_GRAY}`,
    borderBottom: 'none',
    padding: theme.spacing(1.5),
  },
  titleText: {
    ...theme.typography.h2,
    margin: theme.spacing(0,0,0,1),
  },
}), { name: MyEvaluationBoardPageTemplate.name });

function MyEvaluationBoardPageTemplate (props: MyEvaluationBoardPageTemplateProps) {
  const { user } = props;
  const classes = useStyles(props);

  const position = getQueryParameter('position') as Position;

  return (
    <PdfPageTemplate
      headerTitle={`My Evaluation Board${position ? ` - ${position.toUpperCase()}` : ''}`}
      headerIconClassName={classes.headerIcon}
      icon={PinIcon}
    >
      <div className={classes.tableWrapper}>
        <div className={classes.titleRow}>
          <div className={classes.titleText}>My Evaluation Board</div>
        </div>

        {(user && !!Object.keys(user).length) && (
          <MyEvaluationBoard
            user={user}
            position={position}
            printed
          />
        )}
      </div>
    </PdfPageTemplate>
  );
}


const mapStateToProps = (state:State) => {
  return {
    user: state.user,
  };
};

export default connect(
  mapStateToProps,
)(MyEvaluationBoardPageTemplate);
